import { Star, Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { REVIEWS } from "./reviewsData";

const Stars = ({ className = "w-4 h-4" }) => (
  <span className="flex gap-0.5 text-[#E8893F]" aria-label="5 stelle su 5">
    {[0, 1, 2, 3, 4].map((i) => <Star key={i} className={`${className} fill-current`} />)}
  </span>
);

const Card = ({ r, i }) => (
  <figure data-testid={`review-card-${i}`} className="w-[300px] sm:w-[360px] shrink-0 flex flex-col rounded-3xl bg-white border border-[#2A1C15]/10 p-7 shadow-[0_12px_32px_rgba(42,28,21,0.06)] transition-transform duration-500 hover:-translate-y-1 hover:rotate-[-0.5deg]">
    <div className="flex items-center justify-between">
      <Stars />
      <Quote className="w-6 h-6 text-[#E8893F]/40" />
    </div>
    {r.t && <h3 className="mt-5 font-serif text-2xl leading-tight">{r.t}</h3>}
    <blockquote className={`${r.t ? "mt-3" : "mt-5"} flex-1 text-sm sm:text-base text-[#2A1C15]/80 leading-relaxed`}>{r.x}</blockquote>
    <figcaption className="mt-6 pt-4 border-t border-[#2A1C15]/10 flex items-center gap-3">
      <span className="grid place-items-center w-9 h-9 rounded-full bg-[#1A110C] text-[#E8893F] font-serif text-sm">{r.n.split(" ").map((w) => w[0]).slice(0, 2).join("")}</span>
      <span className="leading-tight">
        <span data-testid={`review-name-${i}`} className="block text-sm font-semibold">{r.n}</span>
        <span className="block text-xs text-[#2A1C15]/70">{r.c}</span>
      </span>
    </figcaption>
  </figure>
);

const Row = ({ items, offset, reverse }) => (
  <div className="flex overflow-hidden marquee-pause">
    {[0, 1].map((k) => (
      <div key={k} aria-hidden={k === 1} className={`flex shrink-0 gap-5 pr-5 ${reverse ? "animate-[marqueeRev_260s_linear_infinite]" : "animate-[marquee2_260s_linear_infinite]"}`}>
        {items.map((r, i) => <Card key={i} r={r} i={k === 0 ? offset + i : `dup-${offset + i}`} />)}
      </div>
    ))}
  </div>
);

export const Reviews = () => (
  <section id="recensioni" data-testid="reviews-section" className="bg-[#F4EFE6] text-[#2A1C15] py-24 sm:py-36 overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-12 gap-8 items-end mb-14 sm:mb-20">
      <Reveal className="lg:col-span-7">
        <p className="text-xs uppercase tracking-[0.3em] text-[#8C4A28] mb-5">Dicono di noi</p>
        <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
          Clienti <em className="text-[#C9692C]">soddisfatti.</em>
        </h2>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-5 flex items-center gap-6 lg:justify-end">
        <p data-testid="reviews-score" className="font-serif text-7xl sm:text-8xl leading-none">5,0</p>
        <div>
          <Stars className="w-5 h-5" />
          <p data-testid="reviews-count" className="mt-2 text-sm text-[#2A1C15]/75">Media di {REVIEWS.length} recensioni</p>
        </div>
      </Reveal>
    </div>
    <div className="space-y-5">
      <Row items={REVIEWS.slice(0, 19)} offset={0} />
      <Row items={REVIEWS.slice(19)} offset={19} reverse />
    </div>
  </section>
);
